import React, { useEffect, useState } from "react";
import { makeStyles } from "tss-react/mui";
import { Stack, Box, CircularProgress } from "@mui/material";
import TableViewAudiences from "../components/TableViewAudiences.js";

const useStyles = makeStyles()((theme) => ({
  root: {
    display: "flex",
    alignContent: "center",
    alignItems: "center",
    justifyItems: "center",
    //padding: theme.spacing(10),
    direction: "row",
    marginTop: theme.spacing(10),
    height: "100vh"
  },
  audience: {
    minWidth: "365px",
    width: "40vw",
    minHeight: "300px",
    padding: theme.spacing(1),
    textAlign: "center"
  },
  CardMain: {
    color: theme.primary
  },
  CardToggle: {
    paddingTop: theme.spacing(5),
    paddingBottom: theme.spacing(5)
  }
}));

const Audiences = (props) => {
  const { classes } = useStyles();

  const {loginStatus, setLoginStatus} = props;

  return (
    <Stack className={classes.root} spacing={5} sx={{ marginTop:"75px" }}>
      <Box sx={{ display: 'flex',
        alignItems: 'center',
        width: 'fit-content',
      }}>
        {loginStatus.auth &&
      <TableViewAudiences setLoginStatus={setLoginStatus}/>
        }
        {loginStatus.auth === false && <h2>Please login to view your audiences</h2> }
        {loginStatus.auth === null && <CircularProgress /> }
      </Box>
    </Stack>
  )
};

export {Audiences}